import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove platform branding elements
const removeBranding = () => {
  // Remove any element containing Emergent branding
  document.querySelectorAll('a[href*="emergent"], a[href*="Emergent"]').forEach(el => {
    let parent = el.parentElement;
    while (parent && parent !== document.body && parent.id !== 'root') {
      const next = parent.parentElement;
      parent.remove();
      parent = next;
    }
  });
  
  // Remove divs outside root that might contain branding
  document.querySelectorAll('body > div:not(#root)').forEach(el => {
    if (el.innerHTML?.includes('emergent') || el.innerHTML?.includes('Emergent')) {
      el.remove();
    }
  });

  // Remove by checking all fixed position elements in corners
  document.querySelectorAll('a, div').forEach(el => {
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed' && rect.bottom > window.innerHeight - 80 && rect.right > window.innerWidth - 250) {
      if (!el.closest('#root')) {
        el.style.display = 'none';
        el.remove();
      }
    }
  });
};

// Run aggressively
const interval = setInterval(removeBranding, 100);
setTimeout(() => clearInterval(interval), 10000); // Stop after 10s
setInterval(removeBranding, 1000); // Then check every second

window.addEventListener('load', removeBranding);
document.addEventListener('DOMContentLoaded', removeBranding);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
